import { useState, useEffect } from 'react';
import { useTranslation } from '../lib/i18n';

const STORAGE_KEY = 'sa_cookies_accepted';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] bg-white dark:bg-[#0A0A0A] border-t border-slate-200 dark:border-white/10 px-4 py-4 md:px-6 md:py-4 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] dark:shadow-[0_-4px_20px_rgba(0,0,0,0.4)]"
      role="banner"
      aria-label="Cookie notice"
    >
      <div className="max-w-[90rem] mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-slate-600 dark:text-neutral-400 text-sm font-body leading-relaxed">
          {t('cookie.message')}
        </p>
        <button
          onClick={handleAccept}
          className="flex-shrink-0 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-body tracking-widest rounded-sm transition-colors"
        >
          {t('cookie.button')}
        </button>
      </div>
    </div>
  );
}
